import { render, staticRenderFns } from "./landing-page.html?vue&type=template&id=2ce41974&scoped=true&"
import script from "./landing-page.vue?vue&type=script&lang=js&"
export * from "./landing-page.vue?vue&type=script&lang=js&"
import style0 from "./landing-page.css?vue&type=style&index=0&id=2ce41974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce41974",
  null
  
)

export default component.exports